module.exports = "/_next/static/images/ceramic-a538607d3c3d1a656dd9e08a007f7ebc.png";